module.exports = __webpack_public_path__ + "assets/raw-js/basis_transcoder-e8489257f7028a1baa93dd935db39c5d.js";